<template>
    <div>
        <ModalGlobal id="logoutModal" v-if="modalActivate">
            <template #dialogHeadImg>
                <img
                    class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
                    :src="$S3AssetUrl('suf/photopass-logo.png')"
                    alt="logo photo"
                />
            </template>

            <template #dialogHeading>{{
                $t("Forms.title_modal_recover")
            }}</template>

            <template #dialogDescription>{{
                $t("Forms.msg_modal_activate")
            }}</template>

            <router-link
                :title="$t('Forms.login_account')"
                class="w-full flex justify-center rounded-full py-3 px-4 mb-4 bg-yellow-photo cursor-pointer font-semibold mx-auto"
                :to="{ name: 'login' }"
                >{{ $t("Forms.login_account") }}</router-link
            >

            <button
                @click="modalActivate = false"
                :disabled="loading"
                type="button"
                class="w-full flex justify-center rounded-full py-3 px-4 mb-1 border-yellow-photo border bg-white cursor-pointer font-semibold mx-auto"
            >
                Continuar navegando
            </button>
        </ModalGlobal>

        <div class="mb-8"></div>
        <section class="flex flex-col-reverse md:flex-row container mx-auto">
            <!-- Image -->
            <div class="flex w-full md:w-3/5 items-center mx-auto">
                <img
                    alt="logo"
                    class="w-full"
                    :src="$S3AssetUrl('suf/profile/register-user.jpg')"
                />
            </div>

            <!-- Forgot Form | Recovery Account -->
            <div class="flex flex-col w-full md:w-2/5 mx-auto px-4">
                <h2 class="py-2 text-2xl font-bold">
                    {{ $t("Forms.activate_user") }}
                </h2>
                <p class="mb-4"></p>

                <p class="py-3">
                    {{ $t("Forms.if_you_have_account") }}
                    <router-link
                        :to="{ name: 'login' }"
                        class="cursor-pointer text-newxcaret-blue"
                    >
                        {{ $t("Forms.login") }}
                    </router-link>
                </p>

                <ValidationObserver v-slot="{ handleSubmit }">
                    <form
                        @submit.prevent="handleSubmit(activateNewUser)"
                        class="flex flex-col w-full pt-2 pb-6 relative"
                    >
                        <ValidationProvider
                            rules="required|email"
                            v-slot="{ errors }"
                        >
                            <label class="font-bold" :for="$t('Forms.email')">{{
                                $t("Forms.email")
                            }}</label>
                            <input
                                type="text"
                                placeholder="email@dominio.com"
                                :id="$t('Forms.email')"
                                v-model="formActiveNewUser.Email"
                                :class="[
                                    errorLogin.email && 'border-newxcaret-red',
                                ]"
                                class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg"
                            />
                            <p class="txt-error text-red text-xs italic mb-4">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                        <p
                            class="text-red text-xs italic"
                            v-if="errorLogin.email"
                        >
                            {{ responseErrors.Email[0] }}
                        </p>

                        <ValidationProvider
                            rules="required|numeric"
                            v-slot="{ errors }"
                        >
                            <label class="font-bold" for="CodeFor">{{
                                $t("Forms.code_email")
                            }}</label>
                            <input
                                type="text"
                                id="CodeFor"
                                v-model="formActiveNewUser.Code"
                                :name="$t('Forms.code')"
                                :class="[
                                    errorLogin.Code && 'border-newxcaret-red',
                                ]"
                                class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg"
                            />
                            <p class="txt-error text-red text-xs italic mb-4">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                        <p
                            class="text-red text-xs italic"
                            v-if="errorLogin.Code"
                        >
                            {{ responseErrors.Code[0] }}
                        </p>

                        <p class="text-red text-xs italic" v-if="msgApi.error">
                            {{ msgApi.message }}
                        </p>

                        <p
                            class="text-red text-xs italic"
                            v-if="msgApi.success"
                        >
                            {{ msgApi.message }}
                        </p>

                        <button
                            type="submit"
                            class="flex items-center justify-center w-full mt-4 mt-4 md:mx-2 p-2 bg-yellow-photo rounded-full text-sm font-semibold"
                        >
                            {{ $t("Forms.activate_user") }}
                        </button>
                    </form>
                </ValidationObserver>

                <p class="mb-4">
                    <span class="font-semibold">
                    {{ $t("Forms.still_received_activation_code") }}  
                    </span>
                    <router-link
                        :to="{ name: 'resendAccessCode' }"
                        class="cursor-pointer text-newxcaret-blue"
                    >
                        {{ $t("Forms.forward_it_again") }}
                    </router-link>
                </p>
            </div>
        </section>
    </div>
</template>

<script>
import "../validators/index";
import methodUser from "../mixins/methodUser";

import Users from "../mixins/Users";
import SearchPackage from "../photo/searchPackageComponent";
import loginData from "../logic/profile/login";
import registerData from "../logic/profile/register";
import activateNewUserData from "../logic/profile/activateNewUser";
import recoveryPasswordData from "../logic/profile/recoveryPassword";
import validatePasswordData from "../logic/profile/validatePassword";

export default {
    props: [],
    mixins: [methodUser, Users],
    components: {
        SearchPackage
    },
    data: () => ({
        modalActivate: false,
        user: {},
        pathname: window.location.origin + "/",
        BirthdateInput: { name: "Birthdate" },
        loading: false,
        formLogin: {
            Username: "",
            Password: "",
        },
        formRegister: {
            Password: "", //*
            Email: "", //example@email.com
            FirstName: "", //test
            LastName: "", //test
            Phone: "",
            Birthdate: "", //31/12/1982
            Locale: "", //Mexico
            Gender: "", //Masculino
            Title: "", //Sr.
        },
        formActiveNewUser: {
            Email: "", //example@email.com
            Code: "",
            helperBtnSend: true,
        },
        formResetPassword: {
            Email: "", //example@email.com
            Code: "",
            Password: "",
            ConfirmationPassword: "",
            helperBtnSend: true,
        },
        formRecoveryPass: {
            Email: "",
        },
    }),
    watch: {
        activeForm: function () {
            this.errorLogin.statusApiMessage = false;
            this.msgApi.success = false;
            this.msgApi.error = false;
            this.disableAllInputs();
        },
    },
    methods: {
        async login() {
            try {
                this.loading = true;
                // POST request using axios
                let response = await loginData.get(this.formLogin);

                if (this.errorFormInput(response.data, "status")) {
                    //Elemento que recupera todos los error de validacion de campos
                    this.responseErrors = response.data.errors;

                    Object.entries(this.responseErrors).forEach(
                        ([key, value]) => {
                            this.validFieldsRegister(this.responseErrors);
                        }
                    );
                } else {
                    this.errorLogin.username = false;
                    this.errorLogin.password = false;

                    if (this.errorFormInput(response.data, "ACCESS")) {
                        this.activeForm = response.data.ACCESS == true ? 3 : 0;
                        this.setUserLoggedIn(
                            response.data.ACCESS == true ? true : false
                        );
                    } else {
                        if (
                            this.errorFormInput(response.data, "SUCCESS") &&
                            this.errorFormInput(response.data, "MESSAGE")
                        ) {
                            if (response.data.SUCCESS == "false") {
                                this.msgApi.error = true;
                                this.msgApi.message = response.data.MESSAGE;
                            }
                        }
                    }
                }
                //se settea el loadign para desaactivarlo
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        async register() {
            try {
                // POST request using axios
                let response = await registerData.create(this.formRegister);
                this.loading = true;
                this.errorLogin.statusApiMessage = false;

                if (this.errorFormInput(response.data, "status")) {
                    //Elemento que recupera todos los error
                    this.responseErrors = response.data.errors;

                    Object.entries(this.responseErrors).forEach(
                        ([key, value]) => {
                            this.validFieldsRegister(this.responseErrors);
                        }
                    );
                } else {
                    this.errorLogin.email = false;
                    this.errorLogin.password = false;
                    this.errorLogin.birthdate = false;

                    if (this.errorFormInput(response.data, "SUCCESS")) {
                        if (this.errorFormInput(response.data, "SUCCESS")) {
                            if (response.data.SUCCESS == "true") {
                                this.msgApi.error = false;
                                this.msgApi.success = true;
                                this.activeForm = 4;
                                this.formActiveNewUser.Email =
                                    this.formRegister.Email;
                            } else {
                                this.msgApi.error = false;
                                this.msgApi.error = true;
                            }
                            this.msgApi.message = response.data.MESSAGE;
                        }
                    }
                }
                //se settea el loadign para desaactivarlo
                this.loading = false;
            } catch (error) {
                //se settea el loadign para desaactivarlo
                this.loading = false;
                
            }
        },
        async activateNewUser() {
            try {
                this.$store.dispatch("setLoading", true);
                this.errorLogin.statusApiMessage = false;
                // POST request using axios
                let response = await activateNewUserData.create(
                    this.formActiveNewUser
                );

                if (this.errorFormInput(response.data, "status")) {
                    //Elemento que recupera todos los error
                    this.responseErrors = response.data.errors;

                    Object.entries(this.responseErrors).forEach(
                        ([key, value]) => {
                            this.validFieldsRegister(this.responseErrors);
                        }
                    );
                } else {
                    this.errorLogin.email = false;
                    this.errorLogin.Code = false;

                    if (this.errorFormInput(response.data, "SUCCESS")) {
                        if (this.errorFormInput(response.data, "SUCCESS")) {
                            if (response.data.SUCCESS == "true") {
                                Vue.$toast.open({
                                    message: response.data.MESSAGE,
                                    type: "success",
                                });

                                this.$router.push({ name: "login" });
                            } else {
                                Vue.$toast.open({
                                    message: response.data.MESSAGE,
                                    type: "error",
                                });
                            }
                        }
                    }
                }
                //se settea el loadign para desaactivarlo
                this.$store.dispatch("setLoading", false);
            } catch (error) {
                Vue.$toast.open({
                    message: $t("Forms.try_catch_api"),
                    type: "error",
                });
                //se settea el loadign para desaactivarlo
                this.$store.dispatch("setLoading", false);
                
            }
        },
        async recoveryPassword() {
            try {
                // POST request using axios
                let response = await recoveryPasswordData.create(
                    this.formRecoveryPass
                );
                this.loading = true;
                this.errorLogin.statusApiMessage = false;

                if (this.errorFormInput(response.data, "status")) {
                    //Elemento que recupera todos los error
                    this.responseErrors = response.data.errors;

                    Object.entries(this.responseErrors).forEach(
                        ([key, value]) => {
                            this.validFieldsRegister(this.responseErrors);
                        }
                    );
                } else {
                    this.errorLogin.email = false;
                    if (this.errorFormInput(response.data, "SUCCESS")) {
                        if (response.data.SUCCESS == "true") {
                            this.msgApi.error = false;
                            this.msgApi.success = true;
                            this.activeForm = 5;

                            this.makeToast(
                                "success",
                                "¡Te enviamos un enlace a tu correo, para restablecer tu contraseña!"
                            );
                        } else {
                            this.msgApi.error = false;
                            this.msgApi.error = true;
                        }
                        this.msgApi.message = response.data.MESSAGE;
                    }
                }
                //se settea el loadign para desaactivarlo
                this.loading = false;
            } catch (error) {
                
                //se settea el loadign para desaactivarlo
                this.loading = false;
            }
        },
        async validatePassword(valuePassword) {
            try {
                // POST request using axios
                let response = await validatePasswordData.get({
                    Password: valuePassword,
                });
                this.formActiveNewUser.helperBtnSend = true;
                this.responseErrors = response.data;

                Object.entries(this.responseErrors).forEach(([key, value]) => {
                    this.validFieldsRegister(this.responseErrors);
                });

                if (!response.data.count) {
                    this.errorLogin.password = false;
                    this.formActiveNewUser.helperBtnSend = false;
                    this.formResetPassword.helperBtnSend = false;
                } else {
                    this.errorLogin.password = true;
                    this.formActiveNewUser.helperBtnSend = true;
                    this.formResetPassword.helperBtnSend = true;
                }
            } catch (error) {
                
            }
        },
    },
    mounted() {},
};
</script>
